import { useEffect } from 'react';

// Contatore condiviso: con più dialog aperti insieme lo scroll si sblocca solo quando
// l'ultimo si chiude.
let locks = 0;
let previousOverflow: Array<[HTMLElement, string]> = [];

/**
 * Blocca lo scroll della pagina dietro un dialog finché `attivo` è true.
 * Nel portale a scorrere è `<main>` (lo shell è `100vh; overflow: hidden`), non il body:
 * si bloccano entrambi.
 */
export function useBodyScrollLock(attivo = true): void {
  useEffect(() => {
    if (!attivo) return;
    if (locks === 0) {
      const elementi = [document.body, document.querySelector<HTMLElement>('main')];
      previousOverflow = elementi
        .filter((el): el is HTMLElement => el !== null)
        .map((el) => [el, el.style.overflow]);
      for (const [el] of previousOverflow) el.style.overflow = 'hidden';
    }
    locks += 1;
    return () => {
      locks -= 1;
      if (locks === 0) {
        for (const [el, prev] of previousOverflow) el.style.overflow = prev;
        previousOverflow = [];
      }
    };
  }, [attivo]);
}
